import { Component, inject } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { EfateSetupApiService } from 'src/app/shared/services/echo/efate-setup.api.service';

@Component({
  selector: 'app-ef-run',
  templateUrl: './ef-run.component.html',
})
export class EFRunComponent {
  private readonly efateSetupApiService = inject(EfateSetupApiService);

  isLoading: boolean = false;
  isReady: boolean = false;

  async runCake(efateSetupPk?: number): Promise<void> {
    this.isReady = false;

    if (!efateSetupPk || efateSetupPk <= 0) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    try {
      const response = await firstValueFrom(this.efateSetupApiService.runCAKE(efateSetupPk).pipe(take(1)));
      console.log('RunCAKE response', response);
      this.isReady = true;
    } catch (error) {
      console.warn('Error running CAKE', error);
    } finally {
      this.isLoading = false;
    }
  }
}